import { api } from "@/api";

import { QueryProps } from "@/types/Api";
import { Selection, SportEvent } from "@/types/SportsApiResponses";

export interface PopularSelectionsResponse {
  selections: Selection[];
  sportEvents: SportEvent[];
}

interface Params {
  lang?: string;
  count?: number;
}

export const getPopularSelections = async (
  props: QueryProps<Params>
): Promise<PopularSelectionsResponse> => {
  const res = await api.client.get(`/selections-new/popular`, {
    signal: props.signal,
    params: props.params,
  });
  return res.data;
};
